// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTextFilledSvg from "@fishx/icons-svg/es/asn/FileTextFilled";
import FishxIcon from '../components/FishxIcon';

var FileTextFilled = function FileTextFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTextFilledSvg
  }));
};

FileTextFilled.displayName = 'FileTextFilled';
export default React.forwardRef(FileTextFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileTextFilled.js
// module id = 2748
// module chunks = 0